import { render, staticRenderFns } from "./Officer.vue?vue&type=template&id=048919c8&"
import script from "./Officer.vue?vue&type=script&lang=js&"
export * from "./Officer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports